var da = {
  "Add Quantity Breaks to your product page": "Tilføj mængderabatter til din produktside",
  "Add Upsell.com to your ": "Tilføj Upsell.com til din ",
  "All time": "Al tid",
  "and select": "og vælg",
  "button": "knappen",
  "Cart drawer page": "Kurv-skuffe side",
  "Cart page": "Kurv-side",
  "Check status": "Tjek status",
  "Checkout page": "Betalingsside",
  "Click": "Klik på",
  "Click on": "Klik på",
  "Click the": "Klik på",
  "Custom slot": "Brugerdefineret plads",
  "Custom slots": "Brugerdefinerede pladser",
  "Custom Slots": "Brugerdefinerede pladser",
  "contact support.": "kontakt support.",
  "from the right sidebar": "fra højre sidepanel",
  "Go to App Embeds": "Gå til appintegrationer",
  "Go to your Cart drawer page": "Gå til din Kurv-skuffe side",
  "Go to your Cart page": "Gå til din Kurv-side",
  "Go to your Checkout page": "Gå til din Betalingsside",
  "Go to your Order status page": "Gå til din Ordrestatusside",
  "Go to your Post purchase page": "Gå til din Post-purchase side",
  "Go to your Product page": "Gå til din Produktside",
  "Go to your Thank you page": "Gå til din Tak-side",
  "items": "varer",
  "in the left sidebar": "i venstre sidepanel",
  "Last 12 months": "Seneste 12 måneder",
  "Last 30 days": "Seneste 30 dage",
  "Last 365 days": "Seneste 365 dage",
  "Last 7 days": "Seneste 7 dage",
  "Last 90 days": "Seneste 90 dage",
  "Last month": "Sidste måned",
  "Last year": "Sidste år",
  "Make sure": "Sørg for",
  "Need assistance? Contact our support team for help.": "Brug for hjælp? Kontakt vores supportteam.",
  "Order status page": "Ordrestatusside",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Vores app gennemgår i øjeblikket lidt magi for at forbedre din oplevelse.",
  "Post purchase page": "Post-purchase side",
  "Product page": "Produktside",
  "Save": "Gem",
  "Scroll to the bottom and select": "Rul ned til bunden og vælg",
  "Select": "Vælg",
  "Success. Please continue.": "Succes. Fortsæt venligst.",
  "Thank you page": "Tak-side",
  "The Upsell.com team.": "Upsell.com teamet.",
  "The Upsell.com widget is not placed on ": "Upsell.com widget er ikke placeret på ",
  ". Please follow the steps above or ": ". Følg venligst trinene ovenfor eller ",
  "Today": "I dag",
  "toggle is on": "kontakten er slået til",
  "Total": "I alt",
  "under": "under",
  "We apologize for any inconvenience caused,": "Vi beklager ulejligheden,",
  "We apologize for any inconvenience caused.": "Vi beklager ulejligheden.",
  "We'll be done in a few minutes!": "Vi er færdige om få minutter!",
  "We're improving our services!": "Vi forbedrer vores tjenester!",
  "Widget already added": "Widget allerede tilføjet",
  "Yesterday": "I går",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Du aktiverede widgetten i din webshop, men gemte den ikke i Upsell-editoren",
  "You placed the widget on the ": "Du placerede widget på ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", men du gemte det ikke i Shopify editor. Gå venligst tilbage til ",
  " and save the changes.": " og gem ændringerne."
};

export { da as default };
//# sourceMappingURL=da.json.js.map
